module.exports = __webpack_public_path__ + "img/illuminate.a04cdb30.png";